export function LeftIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M17.5 21L10.5 14L17.5 7" stroke="#18191B" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function RightIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M10.5 7L17.5 14L10.5 21" stroke="#18191B" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
